<template>
  <div>
    <h3 style="text-align: center;"><b>DANH SÁCH NHÂN VIÊN THEO THÂM NIÊN CÔNG TÁC</b></h3>
    <h4 style="text-align: center;">tính đến ngày {{toDateThamNien | moment('DD/MM/YYYY')}}</h4>
    <b-table
      id="my-table"
      bordered
      head-variant="dark"
      hover
      striped
      responsive
      small
      :fields="fields"
      :items="items"
      table-variant="light"
    >
     <template #cell(STT)="data">
        {{ data.index + 1 }}
      </template>
      <template v-slot:cell(ngaysinh)="data">{{
        formatDate(data.value)
      }}</template>
      <template v-slot:cell(ngaythuviec)="data">
        <div v-if="data.value!=null && data.value.length >0">
          {{formatDate(data.value)}}
        </div>
        <div v-else>
          {{formatDate(data.item.ngaychinhthuc)}}
        </div>
      </template>
      <!-- <template v-slot:cell(ngaychinhthuc)="data">{{
        formatDate(data.value)
      }}</template> -->
    </b-table>
    <b-badge variant="light">Tổng số: {{ totalRow }}</b-badge>
  </div>
</template>

<script>
import axios from "axios";
export default {
  name: "Report2",
  props: ["toDateThamNien"],
  data() {
    return {
      fields: [
        {
          key: "STT",
          label: "STT",
          thClass: "align-middle",
          thStyle: {width: "15px", textAlign : "center"},
        },
        {
          key: "manhanvien",
          label: "Mã NV",
          sortable: true,
          thClass: "align-middle",
          thStyle: {width: "70px", textAlign : "center"},
        },
        {
          key: "hovaten",
          label: "Họ và tên",
          sortable: true,
          thClass: "align-middle",
          thStyle: {textAlign : "center"},
        },
        {
          key: "gioitinh",
          label: "Giới tính",
          sortable: true,
          thClass: "text-center",
        },
        //@Edit Thanh
        // {
        //   key: "ngaysinh",
        //   label: "Ngày sinh",
        //   sortable: true,
        //   thClass: "text-center",
        //   tdClass: "text-center",
        // },
        {
          key: "vitricongviec",
          label: "Vị trí công việc",
          sortable: true,
          thClass: "align-middle",
          thStyle: {textAlign : "center"},
        },
        {
          key: "donvicongtacshort",
          label: "Đơn vị công tác",
          sortable: true,
          tdClass: "text-center",
          thClass: "align-middle",
          thStyle: {textAlign : "center"},
        },
        {
          key: "ngaythuviec",
          label: "Ngày bắt đầu",
          sortable: true,
          thClass: "align-middle",
          thStyle: {textAlign : "center"},
          tdClass: "text-center",
        },
        // @Edit: neu khong co ngay thu viec lay ngay chinh thuc
        // {
        //   key: "ngaychinhthuc",
        //   label: "Ngày chính thức",
        //   sortable: true,
        //   thClass: "align-middle",
        //   thStyle: {textAlign : "center"},
        //   tdClass: "text-center",
        // },
        {
          key: "thamnien",
          label: "Thâm niên",
          sortable: true,
          thClass: "align-middle",
          thStyle: {textAlign : "center"},
          // tdClass: "text-center",
        },
        {
          key: "loaihopdong",
          label: "Loại hợp đồng",
          sortable: true,
          thClass: "align-middle",
          thStyle: {textAlign : "center"},
        },
        // {
        //   key: "email",
        //   label: "Email",
        //   sortable: true,
        //   thClass: "text-center",
        // },
        // {
        //   key: "tinhtranghoso",
        //   label: "Tình trạng",
        //   sortable: true,
        //   thClass: "text-center",
        //   width: "80px",
        // },
      ],
      items: [],
    };
  },
  // computed: {},
  // beforeRouteEnter(to, from, next) {
  //   let query = Object.assign({}, this.$route.query);
  //     query.report = 1;
  //     axios
  //       .get("/api/employeereport/get", { params: query })
  //       // .get(`/api/employee`, { params: query })
  //       .then((response) => {
  //         this.items = response.data.items;
  //       })
  //       .catch((err) => {});
  // },
  //   beforeRouteUpdate(to, from, next) {

  //   },
  created() {
    this.initData();
  },
  methods: {
    initData() {
      let query = Object.assign({}, this.$route.query);
      query.report = 2;
      query.toDate = this.toDateThamNien;
      axios
        .get(`/api/employeereport/get`, { params: query })
        .then((response) => {
          this.items = response.data.items;
          this.totalRow = response.data.totalRow;
        })
        .catch((err) => {});
    },
    formatDate(value) {
      if (!value) return "";
      return this.$moment(value).format("DD/MM/YYYY");
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
